module.exports = __webpack_public_path__ + "img/download-metamask.7b933dba.webp";